/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_SetupInputs */

const en_mk_cmp_r_setup = /** @type {(inputs: Mk_Cmp_R_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you must install`)
};

const id_mk_cmp_r_setup = /** @type {(inputs: Mk_Cmp_R_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang perlu dipasang`)
};

/**
* | output |
* | --- |
* | "What you must install" |
*
* @param {Mk_Cmp_R_SetupInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_setup = /** @type {((inputs?: Mk_Cmp_R_SetupInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_SetupInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_setup(inputs)
	return en_mk_cmp_r_setup(inputs)
});